import { render } from "./Tables.vue?vue&type=template&id=4aeefcb5&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=4aeefcb5&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/TEAMENSUENO/mi-stock-teamensueno-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aeefcb5"]])

export default __exports__